import '@/config/i18n'
import { AppAuthErrors } from '@codeleap/auth'
import { alert } from '@codeleap/modals'
import { t } from '@lingui/core/macro'

const errors = {
  'auth/wrong-password': t`Email or password is incorrect`,
  'auth/not-registered': t`This user is not registered`,
  'auth/requires-recent-login': t`You need to log in again to continue`,
  'auth/invalid-login-credentials': t`Email or password is incorrect`,
  'auth/too-many-requests': t`Access to this account has been temporarily disabled due to many failed attempts.`,
  'auth/email-in-use': t`This email address is already taken`,
  'auth/email-not-found': t`Could not find an account matching the specified email address`,
  'auth/email-already-in-use': t`This email address is already taken`,
  'auth/invalid-email': t`Email or password is incorrect`,
  'auth/user-disabled': t`Could not find an account with the specified email address and password`,
  'auth/user-not-found': t`Email or password is incorrect`,
  'auth/missing-email': t`Could not find an account matching the specified email address`,
}

export const AuthErrors = new AppAuthErrors(errors, (err, module, args) => {
  const msg = err?.msg?.(args)

  if (!!err && !!msg) {
    alert.error({ title: t`Error`, body: msg })
  } else if (!err) {
    alert.error({ title: t`Error`, body: t`Something went wrong, please try again later` })
  }

  logger.error(`(Auth) ${module ?? 'Auth'} Error`, err)
})